import React from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

const OrderProduct = (props) => {
  console.log('OrderProduct props:', props);
  console.log('Product data structure:', {
    product: props.product?.product,
    edition: props.product?.edition,
    images: props.product?.edition?.images,
    imageUrl: props.product?.edition?.images?.[0]?.image_url
  });
  
  return (
    <React.Fragment>
      <tr>
        <td>
          <div className="d-flex">
            <div className="flex-shrink-0 avatar-md bg-light rounded p-1">
              <img
                src={
                  props.product.edition &&
                  props.product.edition.images &&
                  props.product.edition.images.length > 0
                    ? `${API_BASE_URL}/file/product/image/${props.product.edition.images[0].image_url}`
                    : `${API_BASE_URL}/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp` // Fallback image
                }
                alt={props.product.product?.name || "Product"}
                className="img-fluid d-block"
                onError={(e) => {
                  e.target.src = `${API_BASE_URL}/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp`; // Fallback on error
                  e.target.onerror = null; // Prevent infinite loop
                }}
              />
            </div>
            <div className="flex-grow-1 ms-3">
              <h5 className="fs-15">
                <Link
                  to={`/product-detail?productId=${props.product.product?.id}`}
                  className="link-primary"
                >
                  {props.product.product?.name || "Product Name"}
                </Link>
              </h5>
              <p className="text-muted mb-0">
                Name: <span className="fw-medium">{props.product.product?.name || "N/A"}</span>
              </p>
              <p className="text-muted mb-0">
                Edition: <span className="fw-medium">{props.product.edition?.edition_name || props.product.edition?.color || "Standard"}</span>
              </p>
              <p className="text-muted mb-0">
                SKU: <span className="fw-medium">{props.product.edition?.sku || "N/A"}</span>
              </p>
              
            </div>
          </div>
        </td>
        <td>${props.product.price}</td>
        <td>{props.product.quantity}</td>
         
        <td className="fw-medium text-end">${props.product.total}</td>
      </tr>
    </React.Fragment>
  );
};

export default OrderProduct;
